module.exports = __webpack_public_path__ + "img/電気回路_3_10_2.3f5aae49.png";